module.exports = __webpack_public_path__ + "img/base.7159612d.png";